import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { LanguageService } from '@fcom/ui-translate';
import { ElementTypes, GaContext } from '@fcom/common/interfaces/gtm.interface';

@Component({
  selector: 'fin-country-selection',
  templateUrl: './country-selection.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CountrySelectionComponent implements OnInit {
  private languageService = inject(LanguageService);

  readonly ElementTypes = ElementTypes;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly TRACKING_CONTEXT = GaContext.BOOKING_FLOW;

  countryCode$: Observable<string>;
  lang$: Observable<string>;

  ngOnInit(): void {
    this.countryCode$ = this.languageService.countryCode;
    this.lang$ = this.languageService.langKey;
  }
}
